import React, { useCallback, useEffect, useState } from "react"
import DataDisplayTable from "../../dataDisplayTable"
import { getDateForTableCell } from "../reportTableV2"
import { REP_TPL, REP_V2, USR } from "../../../shared/Data/typeDirs"
import { useAllReportsContext } from "../contextProviders/allReportsContext"
import {
  Box,
  Button as JoyButton,
  Input,
  Typography,
} from '@mui/joy'
import { Row, Col } from 'react-bootstrap'

import AddIcon from '@mui/icons-material/Add'
import { useUserContext } from "../contextProviders/userContext"
import { NewControlManager } from "../../newControlManager"
import { dataSource } from "../../../services/dataSource"
import { ModalContainer } from "../../newControlManager/controlWrappers/containers/modal"
import { createReportTemplateSchema } from "../../../shared/Objects/newReportObjects/defaults/createReportTemplateSchema"
import { useNotificationContext } from "../contextProviders/notificationContext"
import { useNavigate } from "react-router-dom"

const cols = [
  { accessor: 'name', Header: 'Name' },
  { accessor: 'buildingType', Header: 'Building Type' },
  { Header: 'Modified', accessor: 'modified', Cell: getDateForTableCell },
  { Header: 'Modified By', accessor: '_modifiedBy' },
  { Header: 'Created', accessor: 'created', Cell: getDateForTableCell },
  { Header: 'Created By', accessor: '_createdBy' },
  { accessor: REP_V2, show: false },
  { accessor: '_id', show: false }
]
export function PageTemplates(props) {
  const { [REP_TPL]: allTemplates, [REP_V2]: allReports_v2, [USR]: allUsers, } = useAllReportsContext()
  const { user } = useUserContext()
  const displayNotif = useNotificationContext()
  const navigate = useNavigate()

  const [showTemplateModal, setShowTemplateModal] = useState(false)
  const [filter, setFilter] = useState(false)
  const [filteredTemplates, setFilteredTemplates] = useState(allTemplates)

  const mapAllTemplates = useCallback((arr, users) => {
    return arr.map(itm => {
      let modifiedUser = users.find(usr => usr._id === itm._modifiedBy)
      let createdUser = users.find(usr => usr._id === itm._createdBy)

      return {
        ...itm,
        _modifiedBy: modifiedUser && `${modifiedUser.firstName} ${modifiedUser.lastName}`,
        _createdBy: createdUser && `${createdUser.firstName} ${createdUser.lastName}`
      }
    })
  }, [allTemplates])

    useEffect(() => {
      const t_id = setTimeout(() => {
        let templates = mapAllTemplates(allTemplates, allUsers)
        setFilter('')
        setFilteredTemplates(templates)
      })
  
      return () => {
        clearTimeout(t_id)
      }
    }, [allReports_v2, allUsers, mapAllTemplates])

  async function handleRowClick(row) {
    navigate(`/${REP_V2}/${row[REP_V2]._id}`)
  }

  function filterTemplates(f = '') {
    setFilteredTemplates(allTemplates.filter(itm => (itm.name.toLowerCase().includes(f.toLowerCase()))))
    setFilter(f)
  }

  async function saveAsTemplate({ controls }) {
    let { name, buildingType, description, [REP_V2]: reportId } = controls[0]
    if (!name || !buildingType || !reportId) {
      return displayNotif('danger', 'Please fill all required fields: "Template Name", "Building Type", "Report to Template".')
    }
    try {
      console.log('attempting to save report as template', controls[0])
      let newTemplate = await dataSource('remDb')[REP_TPL].put({ name, buildingType, description, [REP_V2]: reportId })
      console.log('made new template', newTemplate)
      navigate(`/${REP_V2}/${reportId}`)
    } catch (e) {
      return displayNotif('danger', `Failed saving template: ${e.message}`)
    }
  }


  return (
    <div className="content-wrapper">
      <DataDisplayTable
        data={filteredTemplates}
        cols={cols}
        onClickEntry={handleRowClick}
        headerChildren={(
          <Box sx={{ width: '100%', 'margin': '0 0 16px 0' }}>
            <Row className="align-items-center g-2">
              <Col xs={12} md={6} className="d-flex align-items-center gap-3">
                <Typography level="h4">Templates</Typography>
                <Box>
                  {['inspector', 'admin'].includes(user.role) ? (
                    <JoyButton color="primary"
                      startDecorator={<AddIcon />} onClick={() => setShowTemplateModal(true)}
                      size="sm"
                      variant="outlined"
                      className={"btn-custom-primary-outlined"}>
                      New Template
                    </JoyButton>
                  ) : null}
                </Box>
              </Col>
              <Col xs={12} md={6} className="d-flex align-items-center justify-content-end gap-2">
                <Input
                  placeholder="Search templates by name..."
                  size="sm"
                  value={filter || ''}
                  onChange={evt => filterTemplates(evt.target.value)}
                  fullWidth
                />
              </Col>
            </Row>
          </Box>
        )}
      />
      <NewControlManager
        onSubmit={saveAsTemplate}
        content={[{ name: '', buildingType: '' }]}
        schemas={[createReportTemplateSchema]}
        source={{ [REP_V2]: allReports_v2 }}
        objectMetadata={{ type: 'Report Template' }}
        options={{
          modules: { container: ModalContainer }, show: showTemplateModal,
          setShow: setShowTemplateModal, isModal: true
        }}
      />
    </div>
  )
}